/* istanbul ignore file */
import { MSALHolder } from '@/lib/msal';
import BaseAPI from './baseServiceV2';
import { AxiosInstance } from 'axios';
import { UserTimelineReport } from './UserCommunicationHistoryTypes';
import { CampaignFunnelReport } from './CampaignActivationFunnelTypes';

class ReportsInternalServiceV2 extends BaseAPI {
    client!: AxiosInstance;

    static instance: ReportsInternalServiceV2;

    private constructor() {
        super();
        (async () => {
            const BASE_URL = (
                await MSALHolder.getInstance()
            ).getSpaConfiguration()?.backendReportsInternalServiceURL;
            this.client = this.getClient(BASE_URL!);
        })();

        ReportsInternalServiceV2.instance = this;
    }

    // companyId rides in the header (the Backoffice convention from getAuthHeaders);
    // the endpoint also accepts it as a query param, but header keeps every report call uniform.
    getUserCommunicationHistory = async (
        companyId: string,
        userId: string
    ): Promise<{ data: UserTimelineReport }> => {
        const headers = await this.getAuthHeaders(companyId);
        return this.client.get('/api/userCommunicationHistory', {
            headers,
            params: { userId }
        });
    };

    // companyId rides in the header (same convention as the per-user report);
    // campaignId + attributionWindowDays are query params. The window is optional —
    // omitting it lets the backend apply its default (7).
    getCampaignActivationFunnel = async (
        companyId: string,
        campaignId: string,
        attributionWindowDays: number
    ): Promise<{ data: CampaignFunnelReport }> => {
        const headers = await this.getAuthHeaders(companyId);
        return this.client.get('/api/campaignActivationFunnel', {
            headers,
            params: { campaignId, attributionWindowDays }
        });
    };

    static getInstance = () => {
        if (this.instance) {
            return this.instance;
        }
        this.instance = new ReportsInternalServiceV2();
        return this.instance;
    };
}

export default ReportsInternalServiceV2;
